// extracted by mini-css-extract-plugin
export default {"billing":"PersonalSubscription_billing__Q8ySD","buttons":"PersonalSubscription_buttons__z-pBF"};